import React, {useState}  from 'react';
import { Card, CardBody, Row, Col,
  FormGroup, Form, Input , Button, Label
 } from "reactstrap";
import Select from "react-select";
import { useSelector, useDispatch } from 'react-redux'

var viewActions = require ('store/view.actions');
var DatePicker = require("reactstrap-date-picker");
var Const = require ('Const'); 

const EvaluationCard = ( { data , token, courseEvals, updateEval, createEval, delEval, closeMe } ) =>  {
    const [ formData, setFormData] = useState({});
    const [ formErrors, setFormErrors] = useState({});

    const evalExists = ( data.evaluation_id ) ;
  
    const {isSaving } = useSelector(state => ({
       isSaving: state.view.loadingModules.savingEvaluation
    }))
    const dispatch = useDispatch() ;
    
const saveButtons = () => {
    return (
              <>
                  <hr />
                  <Button color="success" size="sm" disabled={isSaving}
                      onClick={() => { 
                        if (!evalExists) confirmCreate();
                         else 
                          confirmUpdate ();
                      } }
                      
                      >
                      {isSaving?
                          <i className="nc-icon nc-refresh-69  fa-spin" />
                          :
                          <>
                              <span className="btn-label">
                                  <i className="fa fa-floppy-o" aria-hidden="true"></i>
                              </span>
                              {evalExists?"Modificar":"Grabar"} 
                          </>
                      }
                  </Button>
                      <Button color="danger" size="sm" 
                          onClick={() => { dispatch(viewActions.isLoadingModule('updating_' + data.evaluation_id + "edit" ,false)) ;
                                          closeMe(); } } >
                        <span className="btn-label">
                            <i className="fa fa-trash" aria-hidden="true"></i>
                        </span>
                        Cancelar 
                      </Button>

              </>
      )

}

const confirmCreate = () => {

    let errObj = { error: false};
    
    if (!formData.name) errObj = ({...errObj, error: true,  name: true });   
    if (!formData.short_name)   errObj = ({...errObj, error: true, short_name: true });  
    if (!formData.start_date)  errObj = ({...errObj, error: true, start_date: true });  
    if (!formData.end_date)   errObj = ({...errObj, error: true, end_date: true });  
    if (!formData.evaluation_type)  errObj = ({...errObj, error: true, evaluation_type: true });   

    if (errObj.error ) {
        setFormErrors( errObj);
        return 0;
    } else {
        let ev = {...data, ...formData} ;
        createEval ( token, ev );

        setTimeout(function() { 
            closeMe(false); 
        }, 1000)
    }
 
  }

const confirmUpdate = () => {
 
    if (Object.keys( formData ).length > 0) {

        updateEval ( data.level_id, data.evaluation_id, formData, data.evaluation_id )
      //  setFormData({});
    } 
  setTimeout(function() { 
    dispatch(viewActions.isLoadingModule('updating_' + data.evaluation_id + "edit" ,false)) ;
    closeMe(false); 
}, 1000)
  
  }


  const handleDateChange = (field, newDate) => {
    setFormData({ ...formData, [field]: newDate.substring(0,10)}  )   
  }


const handleInputChange = (event) => {
  setFormData({ ...formData, [event.target.name]: event.target.value}  )
}
        return (

            <div  key="pa" className="content">
              <Card className="card-plain">
                <CardBody>
                  <Form>
                         <FormGroup>
                            <Row>
                                 <Col md="6">
                                    <Label>{formErrors.name?<span style={{color:"#ff0000"}}>Nombre *</span>:<>Nombre</>} </Label>
                                    <Input
                                        defaultValue={data.name}
                                        placeholder="Nombre"
                                        type="text"
                                        name="name"
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                <Col md="6">
                                    <Label>{formErrors.short_name?<span style={{color:"#ff0000"}}>Nombre corto *</span>:<>Nombre corto</>} </Label>
                                    <Input
                                        defaultValue={data.short_name}
                                        placeholder="Nombre corto"
                                        type="text"
                                        name="short_name"
                                        onChange={handleInputChange}
                                    />
                                </Col>
                            </Row>  
                            <Row>
                                 <Col md="6">
                                    <Label>{formErrors.start_date?<span style={{color:"#ff0000"}}>Fecha Inicio *</span>:<>Fecha Inicio</>} </Label>
                                    <DatePicker id      = "example-datepicker" 
                                            showClearButton={false}
                                            value ={ formData.start_date?new Date(formData.start_date).toISOString()
                                                                :( data.start_date?new Date(data.start_date).toISOString():
                                                                                   '')} 
                                            onChange={(newDate) => handleDateChange("start_date", newDate) }
                                                />
                                </Col>
                                <Col md="6">
                                    <Label>{formErrors.end_date?<span style={{color:"#ff0000"}}>Fecha Cierre *</span>:<>Fecha Cierre</>} </Label>
                                    <DatePicker id = "example-datepicker" 
                                            showClearButton={false}
                                            value ={ formData.end_date?new Date(formData.end_date).toISOString()
                                                                :(data.end_date?new Date(data.end_date).toISOString():
                                                                                '')} 
                                            onChange={(newDate, bis) => handleDateChange("end_date", newDate) }
                                                />
                                </Col>
                            </Row>  
                           


                            <Label>{formErrors.evaluation_type?<span style={{color:"#ff0000"}}>Tipo de Calificacion *</span>:<>Tipo de Calificacion</>} </Label>
                                    <Select
                                            classNamePrefix="react-select"
                                            name="evaluation_type"
                                            defaultValue={ Const.getObjectByValue(Const.EVALUATION_TYPES, data.evaluation_type)}
                                            onChange={(sel) => setFormData({ ...formData, 'evaluation_type': sel.value }  ) }
                                            options={ Const.EVALUATION_TYPES}
                                            placeholder="Tipo de calificación"
                                            />
                               
                                    
                               
                            </FormGroup>
                         </Form>
                         {saveButtons()}
                </CardBody>
              </Card>
            </div>

        );
        }

export { EvaluationCard } ;
